import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroSelectStyles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing } from '../../../styles';

export const customSelectStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroSelectStyles(context, definition)}

  :host::part(indicator) {
    background-color: rgba(135, 155, 166, 0.1);
    height: -webkit-fill-available;
    width: auto;
    display: flex;
    margin: 3px -6px 3px 6px;
    aspect-ratio: 1 / 1;
    border-radius: calc(var(--control-corner-radius) * 1px);
    justify-content: center;
    align-items: center;
  }

  :host::part(select-indicator) {
    fill: rgb(135, 155, 166);
    height: 16px;
    width: 16px;
  }
`;
